import { defineMessages } from 'react-intl';

export const chatFrameMessages = defineMessages({
	header_title: {
		id: 'chat_frame.header.title',
		defaultMessage: 'Chat with us!',
		description: 'Title text placed in header of the chat frame',
	},
	header_description: {
		id: 'chat_frame.header.description',
		defaultMessage: 'We are here to help',
		description:
			'Description text placed in header of the chat frame, above the title',
	},
	typing: {
		id: 'chat_frame.messages.typing',
		defaultMessage:
			'{state, select, paused {{sender} wrote something} other {{sender} is typing} }',
		description:
			'"Typing" message displayed in the chat messages list\'s bottom when an agent (or system) is typing a message',
	},
	scroll_to_unread: {
		id: 'chat_frame.messages.scroll_to_unread',
		defaultMessage:
			'{count, plural, one {Scroll to unread message} other {Scroll to unread messages}}',
		description:
			'"Scroll to unread messages" displayed in messages list when there are unread messages',
	},
	unread_messages: {
		id: 'chat_frame.messages.unread_messages',
		defaultMessage:
			'{count, plural, one {There is an unread message} other {There are {count} unread messages}}',
		description: 'Text placed on top of unread messages "block"',
	},
});
